


















































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Inject} from 'vue-typedi';
import {PreparationOrder} from "@/model/preparation/PreparationOrder";
import {PreparationOrderStatus} from "@/model/preparation/PreparationOrderStatus";
import {PreparationOrderProduct} from "@/model/preparation/PreparationOrderProduct";
import {PreparationType} from "@/model/preparation/PreparationType";
import {PreparationService} from "@/services/PreparationService";
import PreparationOrderProductLine from "@/components/preparation/PreparationOrderProductLine.vue";
import ConfirmDialog from '@/components/dialog-box/ConfirmDialog.vue';
import CustomerData from '@/components/CustomerData.vue';
import formatDate from '@/filters/DateFormatter';
import {Quantity} from "@/model/Quantity";
import authentication from '@/configuration/authentication';
import {RoleName} from '@/configuration/roles';

@Component({
  components: {PreparationOrderProductLine, ConfirmDialog, CustomerData},
  filters: {formatDate}
})
export default class PreparationOrderPanel extends Vue {

  @Prop({default: null}) order: PreparationOrder;
  @Prop({default: false}) isDisplayed: boolean;

  @Inject()
  preparationService!: PreparationService;

  public isCancelDialogOpen: boolean = false;
  public isFinishPreparationDialogOpen: boolean = false;
  public displayNotPreparedProducts: boolean = true;

  onPrintExitVoucher() {
    const pdfWindow = window.open('', '_blank');
    this.preparationService.getExitVoucher(this.order.orderNumber)
        .then((pdf: Blob) => pdfWindow.location.href = URL.createObjectURL(pdf))
        .catch(() => pdfWindow.close());
  }

  toggleCard() {
    this.$emit('clickCard', this.order.orderNumber);
  }

  toggleNotPreparedDisplay() {
    this.displayNotPreparedProducts = !this.displayNotPreparedProducts;
  }

  onPreparedQuantityChange(product: PreparationOrderProduct, quantity: Quantity): void {
    this.preparationService.updateProductPreparedQuantity(this.order, product, quantity)
        .catch(() => undefined);
  }
  onMainAction() {
    if (this.order.status === PreparationOrderStatus.TO_PREPARE) {
      this.updateStatus(PreparationOrderStatus.PREPARING);
      return;
    }

    if (this.order.status === PreparationOrderStatus.PREPARING) {
      if (this.notPreparedProducts.length > 0) {
        this.isFinishPreparationDialogOpen = true;
      } else {
        this.finishPreparation();
      }
      return;
    }

    if (this.order.status === PreparationOrderStatus.PREPARED) {
      this.updateStatus(PreparationOrderStatus.DELIVERED);
    }
  }

  finishPreparation() {
    this.updateStatus(PreparationOrderStatus.PREPARED);
  }

  confirmFinishPreparation() {
    this.isFinishPreparationDialogOpen = false;
    this.finishPreparation();
  }

  resetOrder() {
    this.updateStatus(PreparationOrderStatus.TO_PREPARE);
  }

  onCancelClick() {
    this.isCancelDialogOpen = true;
  }

  showCancelRequestText(): boolean {
    return !!this.order.cancellationRequest?.cancellationIssued && !this.isCanceled && !this.isDelivered;
  }

  confirmCancel() {
    this.isCancelDialogOpen = false;
    this.updateStatus(PreparationOrderStatus.CANCELED);
  }

  getCancelDialogTitle(): string {
    return this.order.cancellationRequest?.cancellationIssued ? "Demande d'annulation" : "Annuler la commande";
  }

  getCancelDialogText(): string {
    return "Confirmer vous l'annulation de commande ?";
  }

  private updateStatus(newStatus: PreparationOrderStatus): void {
    const previousStatus = this.order.status;
    this.order.status = newStatus;
    this.preparationService.updateOrderStatus(this.order, newStatus)
        .then(() => this.$emit('onOrderUpdated'))
        .catch(() => {
          this.order.status = previousStatus;
        });
  }

  get isToPrepare(): boolean {
    return this.order.status === PreparationOrderStatus.TO_PREPARE;
  }

  get isInProgress(): boolean {
    return this.order.status === PreparationOrderStatus.PREPARING;
  }

  get isPrepared(): boolean {
    return this.order.status === PreparationOrderStatus.PREPARED;
  }

  get isDelivered(): boolean {
    return this.order.status === PreparationOrderStatus.DELIVERED;
  }

  get isPreparedOrDelivered(): boolean {
    return this.isPrepared || this.isDelivered;
  }

  get isCanceled(): boolean {
    return this.order.status === PreparationOrderStatus.CANCELED;
  }

  get isFailed(): boolean {
    return this.order.status === PreparationOrderStatus.FAILED;
  }

  get canCancelOrder(): boolean {
    return authentication.userHasRoles([RoleName.CENTRAL_ADMIN, RoleName.MANAGER]);
  }

  get isUrgent(): boolean {
    return (this.isToPrepare || this.isInProgress) && this.order.urgent;
  }

  get notPreparedProducts(): PreparationOrderProduct[] {
    return this.order.products.filter(this.isFabMissing);
  }

  get availableProducts(): PreparationOrderProduct[] {
    return this.order.products
        .filter(product => !this.isFabMissing(product))
        .sort(this.byPreparationType);
  }

  private byPreparationType(a: PreparationOrderProduct, b: PreparationOrderProduct): number {
    if (a.preparationType === b.preparationType) {
      return 0;
    }
    return a.preparationType === PreparationType.ASV ? -1 : 1;
  }

  get hasMultipleNotPreparedProducts(): boolean {
    return this.notPreparedProducts.length > 1;
  }

  private isFabMissing(product: PreparationOrderProduct): boolean {
    return product.preparationType === PreparationType.FAB && !product.isProcessed;
  }

  get mainActionLabel(): string {
    if (this.order.status === PreparationOrderStatus.PREPARED) {
      return 'Livrer';
    }
    if (this.order.status === PreparationOrderStatus.PREPARING) {
      return 'Terminer la préparation';
    }
    return 'Préparer';
  }

  get isMobileUser(): boolean{
    return authentication.isMobileUser();
  }

}
